import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const ProtectedRoute = ({ children }) => {
    const { user, loading } = useAuth();
    if (loading) {
        return (
            <div className="grid min-h-[60vh] place-items-center" data-testid="protected-loading">
                <div className="h-10 w-10 animate-spin rounded-full border-2 border-terracotta/30 border-t-terracotta" />
            </div>
        );
    }
    if (!user || !user._id) return <Navigate to="/login" replace />;
    return children;
};

export default ProtectedRoute;
